module.exports = __webpack_public_path__ + "img/volume-up-solid.cc275a79.svg";